import { c as _c } from "react/compiler-runtime";
import React, { type JSX } from "react";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
interface ClosedButtonProps {
  readonly loading?: boolean;
  readonly children: React.ReactNode;
  readonly padding?: string;
  readonly title?: string;
  readonly className?: string;
}

/**
 * Gray button component for closed/ended states
 * Follows the same pattern as other button components
 */
export default function ClosedButton(t0) {
  const $ = _c(7);
  const {
    loading: t1,
    children,
    padding: t2,
    title,
    className: t3
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const padding = t2 === undefined ? "tw-px-2.5 tw-py-2" : t2;
  const className = t3 === undefined ? "" : t3;
  const t4 = `tw-flex tw-w-full tw-gap-x-1.5 tw-items-center tw-justify-center tw-border tw-border-solid tw-border-iron-600 tw-rounded-lg tw-bg-iron-700 tw-text-iron-300 ${padding} tw-text-sm tw-font-medium tw-transition tw-duration-200 tw-ease-out tw-opacity-75 ${className}`;
  let t5;
  if ($[0] !== loading) {
    t5 = loading && <CircleLoader />;
    $[0] = loading;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== children || $[3] !== t4 || $[4] !== t5 || $[5] !== title) {
    t6 = <button disabled={true} type="button" title={title} aria-label={title} className={t4}>{t5}{children}</button>;
    $[2] = children;
    $[3] = t4;
    $[4] = t5;
    $[5] = title;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}